var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlayCircle = function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#play-circle_svg__clip0_8808_58115)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15Zm9.27 15.001-14.455 7.95v-11.31l2 1.1v6.828L20.12 15l-8.305-4.568-2-1.088V7.05L24.27 15Z",
    fill: "currentColor"
  }))));
};

export { SvgPlayCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAgMzAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF84ODA4XzU4MTE1KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUgMEM2LjcxNTczIDAgMCA2LjcxNTczIDAgMTVDMCAyMy4yODQzIDYuNzE1NzMgMzAgMTUgMzBDMjMuMjg0MyAzMCAzMCAyMy4yODQzIDMwIDE1QzMwIDYuNzE1NzMgMjMuMjg0MyAwIDE1IDBaTTI0LjI3MDQgMTUuMDAxTDkuODE1NDMgMjIuOTUxMlYxMS42NDE0TDExLjgxNTQgMTIuNzQwMlYxOS41Njg3TDIwLjEyMDMgMTUuMDAxTDExLjgxNTQgMTAuNDMzM0w5LjgxNTQzIDkuMzQ0NTVWNy4wNTA3OEwyNC4yNzA0IDE1LjAwMVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L2c+Cjwvc3ZnPgo=";